export enum MeterSelectGroupBy {
  None = 'none',
  Commodity = 'commodity',
  Establishment = 'establishment',
}
